import React, { FC } from "react";
import { Textarea, Label, Box } from "theme-ui";
import { InputFieldType } from "./input-types";

export const TextArea: FC<InputFieldType> = ({
  label,
  placeholder,
  required,
  hover,
  value,
  onChange,
}: InputFieldType) => (
  <Box sx={{ gridColumn: "1 / span 2" }}>
    <Label>{label}</Label>
    <Textarea
      placeholder={placeholder}
      required={required}
      title={hover}
      value={value}
      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void =>
        onChange?.(event.target.value)
      }
      maxLength={5000}
    />
  </Box>
);
